import {
  KPI_LOCK_DRAFT_UNREADABLE_MESSAGE,
  KPI_LOCK_UNAVAILABLE_MESSAGE,
  KPI_SUBJECT_LOCKED_MESSAGE,
  isKpiLockDraftUnreadable,
  isKpiLockUnavailable,
  isKpiSubjectLocked
} from '../Kpi/kpiErrorMessage'

const GENERIC_MESSAGE = 'Could not update market visibility. Please try again.'

/**
 * A user-facing message for a failed market-visibility save. The backend rejects
 * changes that would leave an entry's display logic pointing at an item hidden in
 * that market; we turn that into an actionable sentence. The raw error carries
 * only opaque ids (no resolvable labels), so it is not shown to the user.
 */
export const marketVisibilityErrorMessage = (error: unknown): string => {
  if (isKpiSubjectLocked(error)) {
    return KPI_SUBJECT_LOCKED_MESSAGE
  }
  if (isKpiLockDraftUnreadable(error)) {
    return KPI_LOCK_DRAFT_UNREADABLE_MESSAGE
  }
  if (isKpiLockUnavailable(error)) {
    return KPI_LOCK_UNAVAILABLE_MESSAGE
  }
  const raw = error instanceof Error ? error.message : ''
  const isDisplayLogicConflict =
    /market visibility change rejected/i.test(raw) ||
    /display logic would reference items that are not visible/i.test(raw)

  if (isDisplayLogicConflict) {
    return 'Could not update market visibility: this change would hide an item that another question relies on for display logic in one of the selected markets. Update that display logic, or keep the item visible there, and try again.'
  }

  return GENERIC_MESSAGE
}
